import type { EntityScopeFilters } from '../components/ConsensusScopeFilters';

/** Añade family/warehouse/supplier/product repetibles a params de fetchApi. */
export function appendEntityScopeToRecord(
  params: Record<string, string | string[]>,
  filters: EntityScopeFilters,
): void {
  for (const code of filters.family_codes) {
    const existing = params.family;
    if (Array.isArray(existing)) existing.push(code);
    else params.family = existing ? [existing, code] : code;
  }
  for (const code of filters.warehouse_codes) {
    const existing = params.warehouse;
    if (Array.isArray(existing)) existing.push(code);
    else params.warehouse = existing ? [existing, code] : code;
  }
  for (const code of filters.supplier_codes) {
    const existing = params.supplier;
    if (Array.isArray(existing)) existing.push(code);
    else params.supplier = existing ? [existing, code] : code;
  }
  for (const code of filters.product_codes) {
    const existing = params.product;
    if (Array.isArray(existing)) existing.push(code);
    else params.product = existing ? [existing, code] : code;
  }
}

export function appendEntityScopeToSearchParams(
  params: URLSearchParams,
  filters: EntityScopeFilters,
): void {
  for (const code of filters.family_codes) params.append('family', code);
  for (const code of filters.warehouse_codes) params.append('warehouse', code);
  for (const code of filters.supplier_codes) params.append('supplier', code);
  for (const code of filters.product_codes) params.append('product', code);
}
